const v3GlobalCSS = `
    * {
      margin: 0;
      padding: 0;
    }
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }

    body {
      margin: 0 !important;
      font-family: "Source Sans 3", "Lato", Sans-serif;
      font-optical-sizing: auto;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      touch-action: pan-x pan-y;
    }

    html, body {
      height: 100%;
      min-height: -webkit-fill-available;
    }

    #root {
      height: 100%;
      min-height: -webkit-fill-available;
    }

    :root {
      color-scheme: only light;
      --min-fs: 0.6;
      --max-fs: 1;
      --min-vw: 10;
      --max-vw: 5;

      --min-fs-rem: calc(var(--min-fs) * 1rem);
      --max-fs-rem: calc(var(--max-fs) * 1rem);
      --min-vw-rem: calc(var(--min-vw) * 1rem);

      --slope: calc(
        (var(--max-fs) - var(--min-fs)) * 
        (100vw - var(--min-vw-rem)) / 
        (var(--max-vw) - var(--min-vw))
      );

      --html-font-size: clamp(
        var(--min-fs-rem), 
        calc(var(--min-fs-rem) + var(--slope)), 
        var(--max-fs-rem)
      );
    }

    html {
      font-size: var(--html-font-size);
    }

    @media (min-width: 1100px) {
      :root {
        --max-fs: 0.6;
      }
    }

    @media (min-width: 1400px) {
      :root {
        --max-fs: 0.75;
      }
    }

    @media (min-width: 1600px) {
      :root {
        --max-fs: 0.9;
      }
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type="number"] {
      -moz-appearance: textfield;
      appearance: textfield;
    }

    ::-webkit-scrollbar {
      display: none;
    }

    .MuiListItemSecondaryAction-root {
      top: 60% !important;
    }

    .shaking {
      animation: shake 0.5s infinite;
    }

    .blue-border {
      border: 1px solid #044DA1;
      border-radius: 2px;
    }

    @keyframes shake {
      0% { transform: translate(0.2px, 0.2px) rotate(0deg); }
      10% { transform: translate(-0.2px, -0.5px) rotate(-1deg); }
      20% { transform: translate(-0.2px, 0px) rotate(1deg); }
      30% { transform: translate(0.2px, 0.5px) rotate(0deg); }
      40% { transform: translate(0.2px, -0.2px) rotate(1deg); }
      50% { transform: translate(-0.2px, 0.5px) rotate(-1deg); }
      60% { transform: translate(-0.2px, 0.2px) rotate(0deg); }
      70% { transform: translate(0.2px, 0.2px) rotate(-1deg); }
      80% { transform: translate(-0.2px, -0.2px) rotate(1deg); }
      90% { transform: translate(0.2px, 0.5px) rotate(0deg); }
      100% { transform: translate(0.2px, -0.5px) rotate(0deg); }
    }
  :root {
    --auth-title-font-size: clamp(3rem, 2.4rem + 2.6667vw, 5.6rem);
  
    --auth-subtitle-font-size: clamp(3.2rem, 2.7922rem + 1.6732vw, 4.8rem);
    --auth-subtitle-line-height: clamp(4rem, 3.3077rem + 3.0769vw, 7rem);
  
    --auth-caption-font-size: clamp(1.4rem, 1.3538rem + 0.2051vw, 1.6rem);
  
    --auth-card-title-font-size: clamp(2rem, 1.8154rem + 0.8205vw, 2.8rem);
    --auth-card-title-line-height: clamp(2.8rem, 2.6154rem + 0.8205vw, 3.6rem);
  
    --auth-perks-text-font-size: clamp(1.2rem, 1.098rem + 0.4183vw, 1.6rem);
  
    --auth-login-form-title-font-size: clamp(2.2rem, 1.9961rem + 0.8366vw, 3rem);
    --auth-login-form-title-line-height: clamp(2.64rem, 2.3443rem + 1.2131vw, 3.8rem);
  }
  `;

export default v3GlobalCSS;
